import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUserContext } from '../../context/userContext';
import PurchaseTable from '../purchageOrder/PurchaseTable';
import Challan from '../challan/Challan';
import Voucher from '../voucher/Voucher';
import Cashbook from '../cashbook/cashbook';
import BillingTable from './BillingTable';
import FinalBillTable from './finalBill/FinalBillTable';
import RAReports from './RAReports';

function BillingTab() {
  const navigate = useNavigate();
  const { userDetails,langPreference } = useUserContext();
  const [searchParams, setSearchParams] = useSearchParams();

  const getActiveTab = (type)=>{
   return searchParams?.get(type || "tab") || (type === "type" ? "billing" : "client")
  }

  return (
    <>
      {/* <div className="dash-nav1">
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="mb-0 font-blue">{langPreference?.dashboard || "Dashboard"}</h3>
          {userDetails?.roleId?.permission?.includes("poWrite") && (searchParams.get("tab") == "purchase" || searchParams.get("tab") == null) && <button onClick={() => { navigate("/purchase/add"); }} className="create-order">{langPreference?.create_po || "Create Purchase Order"}</button>}
        </div>
      </div> */}
      <div className="dash-table">
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button onClick={() => setSearchParams({tab:getActiveTab("tab"),type: 'billing' })} className={`nav-link ${(getActiveTab("type") == "billing" || getActiveTab("type") == null) && "active"}`} >{langPreference?.billing || "Billing"}</button>
          </li>
          <li className="nav-item" role="presentation">
            <button onClick={() => setSearchParams({tab:getActiveTab("tab"),type: 'final-bill' })} className={`nav-link ${getActiveTab("type") == "final-bill" && "active"}`} >{langPreference?.final_bill || "Final Bill"}</button>
          </li>
          <li className="nav-item" role="presentation">
            <button onClick={() => setSearchParams({tab:getActiveTab("tab"),type: 'ra-reports' })} className={`nav-link ${getActiveTab("type") == "ra-reports" && "active"}`} >{langPreference?.ra_reports || "RA Reports"}</button>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div className={`tab-pane fade ${(getActiveTab("type") == "billing" || getActiveTab("type") == null) && "show active"} `} id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabIndex="0">
            <BillingTable type="tab" />
          </div>
          <div className={`tab-pane fade ${getActiveTab("type") == "final-bill" && "show active"} `} >{getActiveTab("type") == "final-bill" && <FinalBillTable type="tab" />}</div>
          <div className={`tab-pane fade ${getActiveTab("type") == "ra-reports" && "show active"} `} >{getActiveTab("type") == "ra-reports" && <RAReports />}</div>
        </div>
      </div>
    </>
  )
}

export default BillingTab
